<form [formGroup]="signInForm">
    <mat-form-field appearance="outline" style="width: 100%" color="primary">
        <mat-label>{{'auth.sign-in.user-name' | translate}}</mat-label>
        <input matInput name="login" [formControl]="userNameFormControl" autocomplete="off">
        <mat-error *ngIf="userNameFormControl.hasError('required')">
            {{'common.field-required' | translate}}
        </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" style="width: 100%" color="primary">
        <mat-label>{{'auth.sign-in.password' | translate}}</mat-label>
        <input matInput name="password" type="password" [formControl]="passwordFormControl" autocomplete="off">
        <mat-error *ngIf="passwordFormControl.hasError('required')">
            {{'common.field-required' | translate}}
        </mat-error>
    </mat-form-field>
    <div class="form-button-row">
        <div class="form-button-cell">
            <button mat-raised-button color="primary" (click)="signIn()" [disabled]="!signInForm.valid">
                {{'auth.sign-in.login' | translate}}
            </button>
        </div>
        <div class="form-button-cell">
            <a routerLink="/forgot-password">{{'auth.sign-in.forgot-password' | translate}}</a>
        </div>
    </div>
</form>